if (!customElements.get('quick-search')) {
    class QuickSearch extends HTMLElement {
        constructor() {
            super();

            this.quickSearch = this;
            this.headerInput = document.querySelector('input[name="q"]');
            this.headerSearchIcon = document.querySelector('[data-open-search-popup]');
            this.searchResultsWidget = this.quickSearch.getElementsByClassName('quickSearchResultsWidget')[0];

            this.debouncedOnBeforeFocus = debounce((event) => {
                this.doBeforeQuickSearch();
            }, 100);

            this.headerInput.addEventListener('focus', this.debouncedOnBeforeFocus.bind(this));

            if(this.headerSearchIcon){
                this.headerSearchIcon.addEventListener('click', this.debouncedOnBeforeFocus.bind(this));
            }

            if(window.innerWidth <= 1024){
                if(document.querySelector('[data-search-mobile]')){
                    document.querySelectorAll('[data-search-mobile]').forEach((button) => {
                        button.addEventListener('click', this.doBeforeQuickSearch.bind(this));
                    });
                }
            }
        }

        doBeforeQuickSearch(){
            this.renderQuickSearchFromBlock();
        }

        renderQuickSearchFromBlock(){
            if(!this.searchResultsWidget.classList.contains('ajax-loaded')){
                const block = this.searchResultsWidget.querySelector('.quickSearchProduct');

                let url = block?.getAttribute('data-collection'),
                    limit = this.quickSearch.getAttribute('data-limit'),
                    layout = 'grid',
                    imageRatio = this.quickSearch.getAttribute('data-image-ratio'),
                    ratio = this.quickSearch.getAttribute('data-ratio'),
                    action = true,
                    sectionId = 'list-result-block';

                if(url != null && url != undefined) {
                    $.ajax({
                        type: 'GET',
                        url: window.routes.root + '/collections/' + url,
                        cache: false,
                        data: {
                            view: 'ajax_product_card_search',
                            constraint: `limit=${limit}+layout=${layout}+sectionId=${sectionId}+imageRatio=${imageRatio}+action=${action}+portraitAspectRatio=${ratio}`
                        },
                        beforeSend: () => {
                            block.closest('.quickSearchResultsWidget').classList.add('ajax-loaded');
                        },
                        success: (data) => {
                            if (url != '') {
                                const dataMedia = this.addMediaSize(data, imageRatio, ratio, action, limit);
                                block.querySelector('.products-grid').innerHTML = dataMedia;
                            }
                        },
                        complete: () => {
                            if(window.product_swatch_style == 'slider'){
                                var productList = block.querySelectorAll('.product');

                                productList.forEach((element) => {
                                    var product = $(element),
                                        productSwatch = product.find('.card-swatch--slider');
                                    
                                    if(productSwatch.length > 0){
                                        var swatchGrid = productSwatch.find('.swatch');

                                        if(swatchGrid.length > 0){
                                            if(!swatchGrid.hasClass('slick-initialized')){
                                                Shopify.ProductSwatchs.showSwatchSlider({
                                                    slider: swatchGrid,
                                                    onComplete: null
                                                });
                                            }
                                        }
                                    }
                                });
                            }

                            if(window.compare.show){
                                Shopify.ProductCompare.setLocalStorageProductForCompare();
                            }

                            if(window.wishlist.show){
                                Shopify.ProductWishlist.setLocalStorageProductForWishlist();
                            }

                            if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
                                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                            }
                        }
                    });
                } else{
                    this.searchResultsWidget.classList.add('ajax-loaded');

                    if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }
                }
            }
        }

        addMediaSize(data, imageRatio, ratio, action, limit) {
            let htmlMedia = document.createElement('div');
            htmlMedia.innerHTML = data;

            // Media
            const $cardMedia = $(htmlMedia).find('.card-media');
            $cardMedia.removeClass('card-media--');
            $cardMedia.addClass(`card-media--${imageRatio}`);
            if (imageRatio == 'adapt' || imageRatio == 'portrait'){
                $cardMedia.css('padding-bottom', `${ratio}%`);
            } else if (imageRatio == 'square') {
                $cardMedia.css('padding-bottom', `100%`);
            }

            // Action
            const $cardAction = $(htmlMedia).find('.card-action');
            if (action == true) {
                $cardAction.removeClass('d-none')
            } else {
                $cardAction.remove()
            }

            // Limit
            $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();

            return $(htmlMedia).html();
        }
    }

    customElements.define('quick-search', QuickSearch);
}


function shuaxin() {
    let wordsLength = 0
    var searchWords = document.querySelectorAll('.search-words');
    searchWords.forEach(function(words) {
        var items = words.querySelectorAll('.item');
        items.forEach(i => {
            i.classList.remove('show');
        });
        wordsLength = items.length
    });

    let randomNum = 5 // 随机数 一定要小于总长度
    let randomArray = createUniqueRandomArray(wordsLength, randomNum);
    if(randomArray && randomArray.length) {
        var searchWords = document.querySelectorAll('.search-words');
        searchWords.forEach(function(words) {
            var items = words.querySelectorAll('.item');
            randomArray.forEach(index => {
                items[index].classList.add('show');
            });
        });
    }
    
}

function createUniqueRandomArray(x, randomNum) {
    let result = new Set();
    while (result.size < randomNum) {
        result.add(Math.floor(Math.random() * x));
    }

    return Array.from(result);
}

// shuaxin()




function getHotSearchWords() {
    // var urlHot = 'https://user-api.heychic.net/web/config/hotKeyword/pool';
  var urlHot =
  `${heychic_api}/web/config/hotKeyword/pool`;

  // var cachedArrayHot = JSON.parse(localStorage.getItem('searchList')) || [];

fetch(urlHot)
  .then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  })
  .then((data) => {
    if (data.code == 200 && data.data.length) {
    let searchWordsElements = document.querySelectorAll('.search-words');
    const hotSearchWords = data.data; // 假设 data.data 是一个包含热词对象的数组

    // 遍历所有的 .search-words 元素
    searchWordsElements.forEach(searchWords => {
      searchWords.innerHTML = ''; // 清空 .search-words 元素的内容
        // 遍历热词数组
        hotSearchWords.forEach(word => {
            const searchText = document.createElement('li');
            const searchHref = document.createElement('a');

            searchHref.classList.add('link');
            searchHref.href = `/search?q=${word.keyword}`; // 设置 href 属性
            searchHref.textContent = word.title; // 获取热词标题
            searchText.classList.add('item');

            searchText.appendChild(searchHref);
            searchWords.appendChild(searchText); // 将热词标题添加到 .search-words 元素中

            // 绑定点击事件
            searchText.addEventListener('click', (event) => {
                // 实时读取最新历史记录
                let latestCache = JSON.parse(localStorage.getItem('searchList')) || [];
                latestCache.unshift(word.keyword);
                localStorage.setItem('searchList', JSON.stringify(latestCache));
                
                searchReport(word.keyword);
            });

        });
    });

    // pc有蒙层
      if(window.innerWidth > 768){
        document.body.classList.add('open-search');
      }
      
      $('details.header__seach--details').attr('open','true');
    }
  })
  .catch((error) => {
    console.error("Fetch error:", error);
    // 处理错误
  });
}

// getHotSearchWords();


var getShopId = localStorage.getItem("shopId");
function searchReport(keyword){
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
    "shop_id": getShopId || "59363262637",
    "keyword": keyword,
    "customer_id": ShopifyAnalytics.meta.page.customerId || ''
    });

    const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
    };

    fetch(`${heychic_api}/web/product/search`, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}